import isMobileAppRuntime from 'utils/isMobileAppRuntime';

const listeners = new Set();

let state = {
  initialized: false,
  connected: typeof navigator === 'undefined' ? true : navigator.onLine !== false,
  connectionType: 'unknown',
  packStatus: 'idle',
  totalBytes: 0,
  updateBytes: 0,
  downloadedBytes: 0,
  pendingFiles: 0,
  readyFiles: 0,
  lastUpdatedAt: null,
  message: '',
  partial: false,
};

export const getOfflineState = () => ({ ...state });
export const isOnline = () => !isMobileAppRuntime() || state.connected !== false;

export function updateOfflineState(patch = {}) {
  state = { ...state, ...patch };
  listeners.forEach((listener) => {
    try { listener({ ...state }); } catch (_) {}
  });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('flc:offline-status', { detail: { ...state } }));
  }

  return state;
}

export function subscribeOfflineState(listener) {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  listener({ ...state });
  return () => listeners.delete(listener);
}
